import {AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardCrmService} from '@service/dashboard-crm/dashboard-crm.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ClaimsComponent} from '../claims/claims.component';

@Component({
    selector: 'app-crm-claims-page',
    templateUrl: './crm-claims-page.component.html',
    styleUrls: ['crm-claims-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CrmClaimsPageComponent implements OnDestroy, AfterViewInit {
  matTabIndex = 0;
  @ViewChild(ClaimsComponent) claimsComponent?: ClaimsComponent;
  destroy$ = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dashboardService: DashboardCrmService,
  ) {
    this.dashboardService.title = 'CRM - Claims';
    this.activateTabViaPathParam();
  }

  ngAfterViewInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        if (+params?.id && this.claimsComponent) {
          this.claimsComponent.openClaimWithId(+params?.id);
        } else if (params?.id && !+params?.id) {
          this.router.navigate(['crm', 'claims']);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  private activateTabViaPathParam(): void {
    this.activatedRoute.data
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
      this.matTabIndex = data.matTabIndex;
    });
  }

}
